import { Clientes, HeaderPDF } from '../../../Utils/Types'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { Funcoes } from '../../../Utils/Funcoes'
import moment from 'moment'

export class ReportClientesPDF {

  private clientes: Clientes[]
  private headers: HeaderPDF[]
  private corpoDocumento: any
  private body: any
  private dadosEmpresa: any
  private datai: any
  private dataf: any
  private tipoPessoa: any
  private ativo: any
  private siglaUf: any
  private nomeCidade: any

  constructor(clientes: Clientes[], headers: HeaderPDF[], datai: string, dataf: string, tipoPessoa: string, ativo: string, siglaUf: string, nomeCidade: string) {
    this.clientes = clientes;
    this.headers = headers;
    this.datai = datai ? moment(datai).format('DD/MM/YYYY') : datai
    this.dataf = dataf ? moment(dataf).format('DD/MM/YYYY') : dataf
    this.tipoPessoa = tipoPessoa === 'F' ? 'FÍSICA' : tipoPessoa === 'J' ? 'JURIDICA' : ''
    this.ativo = ativo === 'S' ? 'SIM' : ativo === 'N' ? 'NÃO' : ''
    this.siglaUf = siglaUf
    this.nomeCidade = nomeCidade

    this.body = [];
    //this.CriaDocumento();
  }

  /*
  async CriaDocumento() {

    const bBody: any = this.clientes.map((cli) => {
      return [
        { text: cli.nome, fontSize: 10 },
        { text: cli.uf, fontSize: 10 },
        { text: cli.nome_cidade, fontSize: 10 },
        { text: cli.dt_cadastro, fontSize: 10 },
      ];
    });

    this.body = [
      { text: 'Teste1', fontSize: 10 },
      { text: 'Ref 001', fontSize: 10 },
      { text: "10,00", fontSize: 10 },
      { text: "50", fontSize: 10 },
    ];

    const lineHeader = [
      {
        text: '____________________________________________________________________________________________________________________________________________________________________________',
        aligment: 'center',
        fontSize: 5,
        colSpan: 3
      }, {}, {},
    ];

    let content = [this.headers, lineHeader];
    content = [...content, ...this.body];
    this.corpoDocumento = content;

    //return this.GerarDocumento(content);
  }
  
  GerarDocumento() {

    const document = {
      pageSize: 'A4',
      pageMargins: [14, 53, 14, 48],
      header: () => {
        return {
          margin: [14, 12, 14, 0],
          layout: 'noBorders',
          table: {
            widths: ['*'],
            body: [
              [
                { text: 'RELATÓRIO DE CLIENTES', style: 'reportName' }
              ]
            ],
          },
        };
      },
      content: [
        {
          layout: 'noBorders',
          table: {
            headerRows: 1,
            widths: ['*', 55, 55],
            body: this.corpoDocumento
          }
        },
      ],
      footer: (currentPage: number, pageCount: number) => {
        return {
          layout: 'noBorders',
          margin: [14, 0, 14, 22],
          table: {
            widths: ['auto'],
            body: [
              [
                {
                  text: '_________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
                  alignment: 'center',
                  fontSize: 5,
                },
              ],
              [
                [
                  {
                    text: `Página ${currentPage.toString()} de ${pageCount}`,
                    fontSize: 7,
                    alignment: 'right',
                    // horizontal, vertical
                    margin: [3, 0],
                  },
                  {
                    text: '© Lojinha de TI',
                    fontSize: 7,
                    alignment: 'center',
                  },
                ],
              ],
            ],
          },
        };
      },
      styles: {
        reportName: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 4, 0, 0],
        }
      },
    };

    return document;
  }
  */

  async GerarPDF(clientes: Clientes[]) {

    this.dadosEmpresa = Funcoes.GetDadosEmpresa()

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    let dados = clientes.map((item: Clientes) => {
      return [
        { text: item.nome, alignment: 'left', fontSize: 8, margin: [0, 4, 0, 4], border: [false, true, false, false], },
        { text: item.uf || '', alignment: 'center', fontSize: 8, margin: [0, 4, 0, 4], border: [false, true, false, false], },
        { text: item.nome_cidade || '', alignment: 'left', fontSize: 8, margin: [0, 4, 0, 4], border: [false, true, false, false], },
        { text: moment(item.dt_cadastro || '').format('DD/MM/YYYY'), alignment: 'right', fontSize: 8, margin: [0, 4, 0, 4], border: [false, true, false, false], }];
    });

    const details: any = [
      {
        layout: 'Borders',
        margin: [0, 0, 0, 0],
        table: {
          widths: ['*', "*", '*', '*'],
          body: dados
        },
      }
    ];

    const titulo = (currentPage: any, pageCount: any, pageSize: any) => {
      return [
        { text: 'Relatório de Clientes', alignment: 'center', fontSize: 20, style: 'header' },

        { text: 'Relatório de Clientes', alignment: 'center', fontSize: 20, style: 'header' },
      ]
    };


    const footer = (currentPage: number, pageCount: number,) => {
      return [
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [50, 0, 50, 50],
          table: {
            headerRows: 1,
            widths: ['*', '*'],
            body: [
              [
                { text: 'Emissão: ' + moment(new Date()).format('DD/MM/YYYY HH:mm'), alignment: 'left', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },
                { text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },

              ],
            ]
          }
        },
      ]
    };

    const docDefinitions: any = {
      pageSize: 'A4',
      pageMargins: [50, 0, 50, 50],
      content: [

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.dadosEmpresa?.razao || '', bold: true, alignment: 'center', margin: [0, 5, 0, 0], fontSize: 12, border: [false, false, false, false] },],
              [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 1, 0, 0], fontSize: 12, border: [false, false, false, false] },],
              
            ],
          },
        },

        {
          //[left, top, right, bottom]
          layout: 'noBorders',
          style: 'tableExample',
          table: {
            widths: ['100%'],
            body: [
              [{ text: 'Relatório de Clientes', alignment: 'center', fontSize: 15, style: 'header', margin: [0, 1, 0, 1] }],
            ],

          },

        },

        this.datai !== '' || this.dataf !== '' || this.tipoPessoa !== '' || this.ativo !== '' || this.siglaUf !== '' || this.nomeCidade !== '' ?
          {
            //[left, top, right, bottom]
            layout: 'noBorders',
            style: 'tableExample',
            table: {
              widths: ['100%'],
              body: [
                [{ text: 'Filtros Do Relatório: ', bold: true, margin: [0, 0, 0, 0], fontSize: 10, border: [false, true, false, false] }],

              ],

            },

          } : null,

        {
          layout: 'noBorders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            body: [
              [
                this.datai !== '' ?
                  {
                    text: [
                      { text: 'Data Cadastro: ', fontSize: 9 },
                      { text: this.datai, fontSize: 10, bold: true },
                      { text: this.dataf !== '' ? '   à   ' : '', fontSize: 9 },
                      { text: this.dataf, fontSize: 10, bold: true }
                    ],
                    margin: [0, 0, 0, 0]
                  } : null,

                this.tipoPessoa !== '' ?
                  {
                    text: [
                      { text: 'Pessoa: ', fontSize: 9 },
                      { text: this.tipoPessoa, fontSize: 10, bold: true },
                    ],
                    margin: [0, 0, 0, 0]

                  } : null,

                this.ativo !== '' ?
                  {
                    text: [
                      { text: 'Ativo: ', fontSize: 9 },
                      { text: this.ativo, fontSize: 10, bold: true },
                    ],
                    margin: [0, 0, 0, 0]
                  } : null,

                this.siglaUf !== '' ?
                  {
                    text: [
                      { text: 'Estado: ', fontSize: 9 },
                      { text: this.siglaUf, fontSize: 10, bold: true },
                    ],
                    margin: [0, 0, 0, 0]

                  } : null,

                this.nomeCidade !== '' ?
                  {
                    text: [
                      { text: 'Cidade: ', fontSize: 9 },
                      { text: this.nomeCidade, fontSize: 10, bold: true },
                    ],
                    margin: [0, 0, 0, 0]
                  } : null,
              ],
            ],
          },
        },

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            //[left, top, right, bottom]
            widths: ['50%', '10%', '30%', '10%'],
            body: [
              [
                { text: 'Razão Social / Nome', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                { text: 'Estado', alignment: 'right', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                { text: 'Cidade', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                { text: 'Data', alignment: 'right', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
              ],
            ],
          },
        },
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            widths: ['50%', '10%', '30%', '10%'],
            body: dados
          },
        }

      ].filter(Boolean),

      footer: footer
    };

    pdfMake.createPdf(docDefinitions).print();

  }

}